// Scroll to top of collection grid when pagination links are clicked
// Uses event delegation to work with dynamically loaded content

(function() {
  function scrollToCollectionTop() {
    // Find the collection or product grid container
    const target = document.querySelector('.collection') || 
                   document.querySelector('#ProductGridWrapper') || 
                   document.querySelector('.page-width');
    
    if (target) {
      setTimeout(function() {
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 95,
          behavior: typeof FoxTheme !== 'undefined' && FoxTheme.config.motionReduced ? 'auto' : 'smooth'
        });
      }, 100);
    }
  }

  // Use event delegation on document to handle dynamically loaded pagination links
  document.addEventListener('click', function(e) {
    // Check if the clicked element is a pagination link (but not the current page)
    const paginationLink = e.target.closest('a.pagination__item:not(.pagination__item--current)');
    
    if (paginationLink) {
      scrollToCollectionTop();
    }
  });
})();

